namespace Areas.Maintenance.List {
    "use strict";

    var selected: Selected = new Selected();

    var eicMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["EicComponentType", "EicStatus"])

    var importedMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["AuthorizedUser", "RoleType"])

    var initiationMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["BudgetType", "Department", "ProjectInfoStatus"])

    var systemMaintenanceTabItems = Areas.createTabsWithSameAction("Maintenance", "List",
        ["SystemConfigSettings", "SystemProcessEmails", "SystemUsers"])


    export function eicMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(eicMaintenanceTabItems)(params);
    }

    export function importedMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(importedMaintenanceTabItems)(params);
    }

    export function initiationMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(initiationMaintenanceTabItems)(params);
    }

    export function systemMaintenanceTabInitialized(params: any) {
        return Areas.tabInitialized(systemMaintenanceTabItems)(params);
    }
}
